import gql from 'graphql-tag';

export const createJobRole = gql`
  mutation createJobRole($input: JobRoleDataTableInput) {
    createJobRole(input: $input) {
      id
      name
      shiftGroups {
        id
        name
      }
      enabled
      createdAt
      updatedAt
      deletedAt
      version
    }
  }
`;
